export const localizations = resources.localizations;
export const $ = window.$;
export const isSEplan = window.isSEplan;
export const useSEplanLinks = window.useSEplanLinks;
